module.exports = {
  workflowStepConfig: ($stateParams, Api) ->
    return Api.WorkflowStepConfig.query(workflow_step: $stateParams.workflowStepId).$promise.then (workflowStepConfigs) ->
      return workflowStepConfigs[0]
}
